export default [
  {
    letter: "A",
    top_level: "Arts, Culture, and Humanities",
    lower_levels: [
      {
        code: "A01",
        name: "Alliance/Advocacy Organizations",
      },
      {
        code: "A02",
        name: "Management & Technical Assistance",
      },
      {
        code: "A03",
        name: "Professional Societies & Associations",
      },
      {
        code: "A05",
        name: "Research Institutes and/or Public Policy Analysis",
      },
      {
        code: "A11",
        name: "Single Organization Support",
      },
      {
        code: "A12",
        name: "Fund Raising and/or Fund Distribution",
      },
      {
        code: "A19",
        name: "Nonmonetary Support N.E.C.*",
      },
      {
        code: "A20",
        name: "Arts, Cultural Organizations - Multipurpose",
      },
      {
        code: "A23",
        name: "Cultural/Ethnic Awareness",
      },
      {
        code: "A25",
        name: "Arts Education/Schools",
      },
      {
        code: "A26",
        name: "Arts Council/Agency",
      },
      {
        code: "A30",
        name: "Media, Communications Organizations",
      },
      {
        code: "A31",
        name: "Film, Video",
      },
      {
        code: "A32",
        name: "Television",
      },
      {
        code: "A33",
        name: "Printing, Publishing",
      },
      {
        code: "A34",
        name: "Radio",
      },
      {
        code: "A40",
        name: "Visual Arts Organizations",
      },
      {
        code: "A50",
        name: "Museums & Museum Activities",
      },
      {
        code: "A51",
        name: "Art Museums",
      },
      {
        code: "A52",
        name: "Children's Museums",
      },
      {
        code: "A54",
        name: "History Museums",
      },
      {
        code: "A56",
        name: "Natural History, Natural Science Museums",
      },
      {
        code: "A57",
        name: "Science & Technology Museum",
      },
      {
        code: "A60",
        name: "Performing Arts",
      },
      {
        code: "A61",
        name: "Performing Arts Centers",
      },
      {
        code: "A62",
        name: "Dance",
      },
      {
        code: "A63",
        name: "Ballet",
      },
      {
        code: "A65",
        name: "Theater",
      },
      {
        code: "A68",
        name: "Music",
      },
      {
        code: "A69",
        name: "Symphony Orchestras",
      },
      {
        code: "A6A",
        name: "Opera",
      },
      {
        code: "A6B",
        name: "Singing Choral",
      },
      {
        code: "A6C",
        name: "Music Groups, Bands, Ensembles",
      },
      {
        code: "A6E",
        name: "Performing Arts Schools",
      },
      {
        code: "A70",
        name: "Humanities Organizations",
      },
      {
        code: "A80",
        name: "Historical Societies and Related Activities",
      },
      {
        code: "A84",
        name: "Commemorative Events",
      },
      {
        code: "A90",
        name: "Arts Service Activities/ Organizations",
      },
      {
        code: "A99",
        name: "Other Art, Culture, Humanities Organizations/Services N.E.C.",
      },
    ],
  },
  {
    letter: "B",
    top_level: "Educational Institutions",
    lower_levels: [
      {
        code: "B01",
        name: "Alliance/Advocacy Organizations",
      },
      {
        code: "B02",
        name: "Management & Technical Assistance",
      },
      {
        code: "B03",
        name: "Professional Societies & Associations",
      },
      {
        code: "B05",
        name: "Research Institutes and/or Public Policy Analysis",
      },
      {
        code: "B11",
        name: "Single Organization Support",
      },
      {
        code: "B12",
        name: "Fund Raising and/or Fund Distribution",
      },
      {
        code: "B19",
        name: "Nonmonetary Support N.E.C.*",
      },

      {
        code: "B20",
        name: "Elementary, Secondary Ed",
      },

      {
        code: "B21",
        name: "Kindergarten, Nursery Schools, Preschool, Early Admissions",
      },
      {
        code: "B24",
        name: "Primary/Elementary School",
      },
      {
        code: "B25",
        name: "Secondary/High School",
      },
      {
        code: "B28",
        name: "Special Ed Institutions/ Schools for Visually or Hearing Impaired, Learning Disabled",
      },

      {
        code: "B30",
        name: "Vocational Technical",
      },

      {
        code: "B40",
        name: "Higher Ed Institutions",
      },

      {
        code: "B41",
        name: "Community/Jr. College",
      },
      {
        code: "B42",
        name: "Undergraduate College (4-year)",
      },
      {
        code: "B43",
        name: "University or Technological",
      },

      {
        code: "B50",
        name: "Graduate, Professional (Separate Entities)",
      },

      {
        code: "B60",
        name: "Adult, Continuing Ed",
      },

      {
        code: "B70",
        name: "Libraries, Library Science",
      },

      {
        code: "B80",
        name: "Student Services and Organizations",
      },

      {
        code: "B82",
        name: "Scholarships, Student Financial Aid, Awards",
      },
      {
        code: "B83",
        name: "Student Sororities, Fraternities",
      },
      {
        code: "B84",
        name: "Alumni Associations",
      },

      {
        code: "B90",
        name: "Educational Services and Schools - Other",
      },

      {
        code: "B92",
        name: "Remedial Reading, Reading Encouragement",
      },
      {
        code: "B94",
        name: "Parent Teacher Group",
      },

      {
        code: "B99",
        name: "Education N.E.C.",
      },
    ],
  },
  {
    letter: "C",
    top_level: "Environmental Quality Protection, Beautification",
    lower_levels: [
      {
        code: "C01",
        name: "Alliance/Advocacy Organizations",
      },
      {
        code: "C02",
        name: "Management & Technical Assistance",
      },
      {
        code: "C03",
        name: "Professional Societies & Associations",
      },
      {
        code: "C05",
        name: "Research Institutes and/or Public Policy Analysis",
      },
      {
        code: "C11",
        name: "Single Organization Support",
      },
      {
        code: "C12",
        name: "Fund Raising and/or Fund Distribution",
      },
      {
        code: "C19",
        name: "Nonmonetary Support N.E.C.*",
      },

      {
        code: "C20",
        name: "Pollution Abatement and Control Services",
      },

      {
        code: "C27",
        name: "Recycling",
      },

      {
        code: "C30",
        name: "Natural Resource Conservation and Protection",
      },

      {
        code: "C32",
        name: "Water Resource, Wetlands Conservation & Management",
      },
      {
        code: "C34",
        name: "Land Resources Conservation",
      },
      {
        code: "C35",
        name: "Energy Resources Conservation & Development",
      },
      {
        code: "C36",
        name: "Forest Conservation",
      },

      {
        code: "C40",
        name: "Botanical, Horticultural, and Landscape Services",
      },

      {
        code: "C41",
        name: "Botanical Gardens, Arboreta and Botanical Organizations",
      },
      {
        code: "C42",
        name: "Garden Club, Horticultural Programs",
      },

      {
        code: "C50",
        name: "Environmental Beautification",
      },

      {
        code: "C60",
        name: "Environmental Education and Outdoor Survival Programs",
      },

      {
        code: "C99",
        name: "Environmental Quality Protection and Beautification N.E.C.",
      },
    ],
  },
  {
    letter: "D",
    top_level: "Animal related",
    lower_levels: [
      {
        code: "D01",
        name: "Alliance/Advocacy Organizations",
      },
      {
        code: "D02",
        name: "Management & Technical Assistance",
      },
      {
        code: "D03",
        name: "Professional Societies & Associations",
      },
      {
        code: "D05",
        name: "Research Institutes and/or Public Policy Analysis",
      },
      {
        code: "D11",
        name: "Single Organization Support",
      },
      {
        code: "D12",
        name: "Fund Raising and/or Fund Distribution",
      },
      {
        code: "D19",
        name: "Nonmonetary Support N.E.C.*",
      },

      {
        code: "D20",
        name: "Animal Protection and Welfare (includes Humane Societies and SPCAs)",
      },

      {
        code: "D30",
        name: "Wildlife Preservation/ Protection",
      },

      {
        code: "D31",
        name: "Protection of Endangered Species",
      },
      {
        code: "D32",
        name: "Bird Sanctuary/Preserve",
      },
      {
        code: "D33",
        name: "Fisheries",
      },
      {
        code: "D34",
        name: "Wildlife Sanctuary/Refuge",
      },

      {
        code: "D40",
        name: "Veterinary Services",
      },

      {
        code: "D50",
        name: "Zoo, Zoological Society",
      },

      {
        code: "D60",
        name: "Other Services, Specialty Animals",
      },

      {
        code: "D61",
        name: "Animal Training/Behavior",
      },

      {
        code: "D99",
        name: "Animal Related Activities N.E.C.",
      },
    ],
  },
  {
    letter: "E",
    top_level: "Health:General & Rehabilitative",
    lower_levels: [
      {
        code: "E01",
        name: "Alliance/Advocacy Organizations",
      },
      {
        code: "E02",
        name: "Management & Technical Assistance",
      },
      {
        code: "E03",
        name: "Professional Societies & Associations",
      },
      {
        code: "E05",
        name: "Research Institutes and/or Public Policy Analysis",
      },
      {
        code: "E11",
        name: "Single Organization Support",
      },
      {
        code: "E12",
        name: "Fund Raising and/or Fund Distribution",
      },
      {
        code: "E19",
        name: "Nonmonetary Support N.E.C.*",
      },

      {
        code: "E20",
        name: "Hospitals and Primary Medical Care Facilities",
      },

      {
        code: "E21",
        name: "Community Health Systems",
      },
      {
        code: "E22",
        name: "Hospital (General)",
      },
      {
        code: "E24",
        name: "Hospital (Specialty)",
      },

      {
        code: "E30",
        name: "Health Treatment Facilities (Primarily Outpatient)",
      },

      {
        code: "E31",
        name: "Group Health Practice (HMOs)",
      },
      {
        code: "E32",
        name: "Ambulatory Health Center, Community Clinic",
      },

      {
        code: "E40",
        name: "Reproductive Health Care Facilities and Allied Services",
      },

      {
        code: "E42",
        name: "Family Planning Centers",
      },

      {
        code: "E50",
        name: "Rehabilitative Medical Services",
      },

      {
        code: "E60",
        name: "Health Support Services",
      },

      {
        code: "E61",
        name: "Blood Supply Related",
      },
      {
        code: "E62",
        name: "Ambulance/Emergency Transport",
      },
      {
        code: "E65",
        name: "Organ and Tissue Bank",
      },

      {
        code: "E70",
        name: "Public Health Programs",
      },

      {
        code: "E80",
        name: "Health (General and Financing)",
      },

      {
        code: "E86",
        name: "Patient Services�Entertainment, Recreation",
      },

      {
        code: "E90",
        name: "Nursing Services General (includes Candy Stripers)",
      },

      {
        code: "E91",
        name: "Nursing, Convalescent (Geriatric and Nursing)",
      },
      {
        code: "E92",
        name: "Home Health Care (includes Visiting Nurse Associations)",
      },

      {
        code: "E99",
        name: "Health - General & Rehabilitative N.E.C.",
      },
    ],
  },
  {
    letter: "F",
    top_level: "Mental Health, Crisis Intervention",
    lower_levels: [
      {
        code: "F01",
        name: "Alliance/Advocacy Organizations",
      },
      {
        code: "F02",
        name: "Management & Technical Assistance",
      },
      {
        code: "F03",
        name: "Professional Societies & Associations",
      },
      {
        code: "F05",
        name: "Research Institutes and/or Public Policy Analysis",
      },
      {
        code: "F11",
        name: "Single Organization Support",
      },
      {
        code: "F12",
        name: "Fund Raising and/or Fund Distribution",
      },
      {
        code: "F19",
        name: "Nonmonetary Support N.E.C.*",
      },

      {
        code: "F20",
        name: "Alcohol, Drug, and Substance Abuse, Dependency, Prevention & Treatment",
      },

      {
        code: "F21",
        name: "Alcohol, Drug Abuse (Prevention Only)",
      },
      {
        code: "F22",
        name: "Alcohol, Drug Abuse (Treatment Only)",
      },

      {
        code: "F30",
        name: "Mental Health Treatment",
      },

      {
        code: "F31",
        name: "Psychiatric, Mental Health Hospital",
      },
      {
        code: "F32",
        name: "Community Mental Health Center",
      },
      {
        code: "F33",
        name: "Group Home, Residential Treatment Facility - Mental Health Related",
      },

      {
        code: "F40",
        name: "Hot Line, Crisis Intervention",
      },

      {
        code: "F42",
        name: "Rape Victim Services",
      },

      {
        code: "F50",
        name: "Addictive Disorders",
      },

      {
        code: "F52",
        name: "Smoking",
      },
      {
        code: "F53",
        name: "Eating Disorder",
      },
      {
        code: "F54",
        name: "Gambling",
      },

      {
        code: "F60",
        name: "Counseling Support Groups",
      },

      {
        code: "F70",
        name: "Mental Health Disorders",
      },

      {
        code: "F80",
        name: "Mental Health Associations - Multipurpose",
      },

      {
        code: "F99",
        name: "Other Mental Health, Crisis Intervention N.E.C.",
      },
    ],
  },
  {
    letter: "G",
    top_level: "Disease, Disorders, Medical Disciplines",
    lower_levels: [
      {
        code: "G01",
        name: "Alliance/Advocacy Organizations",
      },
      {
        code: "G02",
        name: "Management & Technical Assistance",
      },
      {
        code: "G03",
        name: "Professional Societies & Associations",
      },
      {
        code: "G05",
        name: "Research Institutes and/or Public Policy Analysis",
      },
      {
        code: "G11",
        name: "Single Organization Support",
      },
      {
        code: "G12",
        name: "Fund Raising and/or Fund Distribution",
      },
      {
        code: "G19",
        name: "Nonmonetary Support N.E.C.*",
      },

      {
        code: "G20",
        name: "Birth Defects, Genetic Diseases",
      },

      {
        code: "G25",
        name: "Down's Syndrome",
      },

      {
        code: "G30",
        name: "Cancer",
      },

      {
        code: "G40",
        name: "Diseases of Specific Organs",
      },

      {
        code: "G41",
        name: "Eye Diseases, Blindness & Vision Impairment",
      },
      {
        code: "G42",
        name: "Ear/Throat",
      },
      {
        code: "G43",
        name: "Heart and Circulatory System",
      },
      {
        code: "G44",
        name: "Kidney",
      },
      {
        code: "G45",
        name: "Lung",
      },
      {
        code: "G48",
        name: "Brain Disorders",
      },

      {
        code: "G50",
        name: "Nerve, Muscle, and Bone Diseases",
      },

      {
        code: "G51",
        name: "Arthritis",
      },
      {
        code: "G54",
        name: "Epilepsy",
      },

      {
        code: "G60",
        name: "Allergy Related Diseases",
      },

      {
        code: "G61",
        name: "Asthma",
      },

      {
        code: "G70",
        name: "Digestive Diseases, Disorders",
      },

      {
        code: "G80",
        name: "Specifically Named Diseases",
      },

      {
        code: "G81",
        name: "AIDS",
      },
      {
        code: "G83",
        name: "Alzheimer's",
      },
      {
        code: "G84",
        name: "Autism",
      },

      {
        code: "G90",
        name: "Medical Disciplines",
      },

      {
        code: "G92",
        name: "Biomedicine, Bioengineering",
      },
      {
        code: "G94",
        name: "Geriatrics",
      },
      {
        code: "G96",
        name: "Neurology, Neuroscience",
      },
      {
        code: "G98",
        name: "Pediatrics",
      },
      {
        code: "G9B",
        name: "Surgery",
      },

      {
        code: "G99",
        name: "Diseases, Disorders, Medical Disciplines N.E.C.",
      },
    ],
  },
  {
    letter: "H",
    top_level: "Medical Research",
    lower_levels: [
      {
        code: "H01",
        name: "Alliance/Advocacy Organizations",
      },
      {
        code: "H02",
        name: "Management & Technical Assistance",
      },
      {
        code: "H03",
        name: "Professional Societies & Associations",
      },
      {
        code: "H05",
        name: "Research Institutes and/or Public Policy Analysis",
      },
      {
        code: "H11",
        name: "Single Organization Support",
      },
      {
        code: "H12",
        name: "Fund Raising and/or Fund Distribution",
      },
      {
        code: "H19",
        name: "Nonmonetary Support N.E.C.*",
      },

      {
        code: "H20",
        name: "Birth Defects, Genetic Diseases Research",
      },

      {
        code: "H25",
        name: "Down's Syndrome",
      },

      {
        code: "H30",
        name: "Cancer Research",
      },

      {
        code: "H40",
        name: "Specific Organ Research",
      },

      {
        code: "H41",
        name: "Eye",
      },
      {
        code: "H42",
        name: "Ear and Throat",
      },
      {
        code: "H43",
        name: "Heart and Circulatory",
      },
      {
        code: "H44",
        name: "Kidney",
      },
      {
        code: "H45",
        name: "Lung",
      },
      {
        code: "H48",
        name: "Brain Disorders",
      },

      {
        code: "H50",
        name: "Nerve, Muscle, and Bone Research",
      },

      {
        code: "H51",
        name: "Arthritis",
      },
      {
        code: "H54",
        name: "Epilepsy Research",
      },

      {
        code: "H60",
        name: "Allergy Related Diseases Research",
      },

      {
        code: "H61",
        name: "Asthma",
      },

      {
        code: "H70",
        name: "Digestive Diseases/Disorders Research",
      },

      {
        code: "H80",
        name: "Specifically Named Diseases Research",
      },

      {
        code: "H81",
        name: "AIDS",
      },
      {
        code: "H83",
        name: "Alzheimer's",
      },
      {
        code: "H84",
        name: "Autism",
      },

      {
        code: "H90",
        name: "Medical Specialty Research",
      },

      {
        code: "H92",
        name: "Biomedicine, Bioengineering",
      },
      {
        code: "H94",
        name: "Geriatrics",
      },
      {
        code: "H96",
        name: "Neurology, Neuroscience",
      },
      {
        code: "H98",
        name: "Pediatrics Research",
      },
      {
        code: "H9B",
        name: "Surgery",
      },

      {
        code: "H99",
        name: "Other Medical Research N.E.C.",
      },
    ],
  },
  {
    letter: "I",
    top_level: "Crime, Legal Related",
    lower_levels: [
      {
        code: "I01",
        name: "Alliance/Advocacy Organizations",
      },
      {
        code: "I02",
        name: "Management & Technical Assistance",
      },
      {
        code: "I03",
        name: "Professional Societies & Associations",
      },
      {
        code: "I05",
        name: "Research Institutes and/or Public Policy Analysis",
      },
      {
        code: "I11",
        name: "Single Organization Support",
      },
      {
        code: "I12",
        name: "Fund Raising and/or Fund Distribution",
      },
      {
        code: "I19",
        name: "Nonmonetary Support N.E.C.*",
      },

      {
        code: "I20",
        name: "Crime Prevention N.E.C.",
      },

      {
        code: "I21",
        name: "Delinquency Prevention",
      },
      {
        code: "I23",
        name: "Drunk Driving Related",
      },

      {
        code: "I30",
        name: "Correctional Facilities N.E.C.",
      },

      {
        code: "I31",
        name: "Transitional Care, Half-Way House for Offenders/Ex-Offenders",
      },

      {
        code: "I40",
        name: "Rehabilitation Services for Offenders",
      },

      {
        code: "I43",
        name: "Services to Prisoners/Families",
      },
      {
        code: "I44",
        name: "Prison Alternatives",
      },

      {
        code: "I50",
        name: "Administration of Justice, Courts (Court Administration, Court Reform, Alternatives to Litigation and Sentencing)",
      },

      {
        code: "I51",
        name: "Dispute Resolution/ Mediation Services",
      },

      {
        code: "I60",
        name: "Law Enforcement Agencies (Police Departments)",
      },

      {
        code: "I70",
        name: "Protection Against and Prevention of Neglect, Abuse, Exploitation",
      },

      {
        code: "I71",
        name: "Spouse Abuse, Prevention of",
      },
      {
        code: "I72",
        name: "Child Abuse, Prevention of",
      },
      {
        code: "I73",
        name: "Sexual Abuse, Prevention of",
      },

      {
        code: "I80",
        name: "Legal Services",
      },

      {
        code: "I83",
        name: "Public Interest Law/Litigation",
      },

      {
        code: "I99",
        name: "Crime, Legal Related N.E.C.",
      },
    ],
  },
  {
    letter: "J",
    top_level: "Employment, Job Related",
    lower_levels: [
      {
        code: "J01",
        name: "Alliance/Advocacy Organizations",
      },
      {
        code: "J02",
        name: "Management & Technical Assistance",
      },
      {
        code: "J03",
        name: "Professional Societies & Associations",
      },
      {
        code: "J05",
        name: "Research Institutes and/or Public Policy Analysis",
      },
      {
        code: "J11",
        name: "Single Organization Support",
      },
      {
        code: "J12",
        name: "Fund Raising and/or Fund Distribution",
      },
      {
        code: "J19",
        name: "Nonmonetary Support N.E.C.*",
      },

      {
        code: "J20",
        name: "Employment Procurement Assistance and Job Training",
      },

      {
        code: "J21",
        name: "Vocational Counseling/ Guidance/Testing",
      },
      {
        code: "J22",
        name: "Employment Training",
      },

      {
        code: "J30",
        name: "Vocational Rehabilitation (includes Job Training and Employment for Disabled and Elderly)",
      },

      {
        code: "J32",
        name: "Goodwill Industries",
      },
      {
        code: "J33",
        name: "Sheltered Remunerative Employment, Work Activity Center N.E.C.",
      },

      {
        code: "J40",
        name: "Labor Unions/Organizations",
      },
      {
        code: "J99",
        name: "Employment, Job Related N.E.C.",
      },
    ],
  },
  {
    letter: "K",
    top_level: "Agriculture, Food, Nutrition",
    lower_levels: [
      {
        code: "K01",
        name: "Alliance/Advocacy Organizations",
      },
      {
        code: "K02",
        name: "Management & Technical Assistance",
      },
      {
        code: "K03",
        name: "Professional Societies & Associations",
      },
      {
        code: "K05",
        name: "Research Institutes and/or Public Policy Analysis",
      },
      {
        code: "K11",
        name: "Single Organization Support",
      },
      {
        code: "K12",
        name: "Fund Raising and/or Fund Distribution",
      },
      {
        code: "K19",
        name: "Nonmonetary Support N.E.C.*",
      },

      {
        code: "K20",
        name: "Agricultural Programs",
      },

      {
        code: "K25",
        name: "Farmland Preservation",
      },
      {
        code: "K26",
        name: "Livestock Breeding, Development, Management",
      },
      {
        code: "K28",
        name: "Farm Bureau",
      },

      {
        code: "K30",
        name: "Food Service, Free Food Distribution Programs",
      },

      {
        code: "K31",
        name: "Food Banks, Food Pantries",
      },
      {
        code: "K34",
        name: "Congregate Meals",
      },
      {
        code: "K35",
        name: "Organization-Sponsored Eatery or Agency",
      },
      {
        code: "K36",
        name: "Meals on Wheels",
      },

      {
        code: "K40",
        name: "Nutrition Programs",
      },

      {
        code: "K50",
        name: "Home Economics",
      },

      {
        code: "K99",
        name: "Other Food, Agriculture, Nutrition N.E.C.",
      },
    ],
  },
  {
    letter: "L",
    top_level: "Housing, Shelter",
    lower_levels: [
      {
        code: "L01",
        name: "Alliance/Advocacy Organizations",
      },
      {
        code: "L02",
        name: "Management & Technical Assistance",
      },
      {
        code: "L03",
        name: "Professional Societies & Associations",
      },
      {
        code: "L05",
        name: "Research Institutes and/or Public Policy Analysis",
      },
      {
        code: "L11",
        name: "Single Organization Support",
      },
      {
        code: "L12",
        name: "Fund Raising and/or Fund Distribution",
      },
      {
        code: "L19",
        name: "Nonmonetary Support N.E.C.*",
      },

      {
        code: "L20",
        name: "Housing Development, Construction, Management",
      },

      {
        code: "L21",
        name: "Public Housing",
      },
      {
        code: "L22",
        name: "Senior Citizens' Housing, Retirement Communities",
      },
      {
        code: "L25",
        name: "Housing Rehabilitation",
      },

      {
        code: "L30",
        name: "Housing Search Assistance",
      },

      {
        code: "L40",
        name: "Low-Cost Temporary Housing (includes Youth Hostels)",
      },

      {
        code: "L41",
        name: "Temporary Shelter for the Homeless",
      },

      {
        code: "L50",
        name: "Housing Owners, Renters Organizations",
      },

      {
        code: "L80",
        name: "Other Housing Support Services",
      },

      {
        code: "L81",
        name: "Home Improvement/Repairs",
      },
      {
        code: "L82",
        name: "Housing Expense Reduction Support, Rent Assistance",
      },

      {
        code: "L99",
        name: "Other Housing, Shelter N.E.C.",
      },
    ],
  },
  {
    letter: "M",
    top_level: "Public Safety, Disaster Preparedness and Relief",
    lower_levels: [
      {
        code: "M01",
        name: "Alliance/Advocacy Organizations",
      },
      {
        code: "M02",
        name: "Management & Technical Assistance",
      },
      {
        code: "M03",
        name: "Professional Societies & Associations",
      },
      {
        code: "M05",
        name: "Research Institutes and/or Public Policy Analysis",
      },
      {
        code: "M11",
        name: "Single Organization Support",
      },
      {
        code: "M12",
        name: "Fund Raising and/or Fund Distribution",
      },
      {
        code: "M19",
        name: "Nonmonetary Support N.E.C.*",
      },

      {
        code: "M20",
        name: "Disaster Preparedness and Relief Service",
      },

      {
        code: "M23",
        name: "Search and Rescue Services",
      },
      {
        code: "M24",
        name: "Fire Prevention/ Protection/Control",
      },

      {
        code: "M40",
        name: "Safety Education",
      },

      {
        code: "M41",
        name: "First Aid Training",
      },
      {
        code: "M42",
        name: "Automotive Safety",
      },

      {
        code: "M99",
        name: "Other Public Safety, Disaster Preparedness and Relief N.E.C.",
      },
    ],
  },
  {
    letter: "N",
    top_level: "Recreation, Sports, Leisure, Athletics",
    lower_levels: [
      {
        code: "N01",
        name: "Alliance/Advocacy Organizations",
      },
      {
        code: "N02",
        name: "Management & Technical Assistance",
      },
      {
        code: "N03",
        name: "Professional Societies & Associations",
      },
      {
        code: "N05",
        name: "Research Institutes and/or Public Policy Analysis",
      },
      {
        code: "N11",
        name: "Single Organization Support",
      },
      {
        code: "N12",
        name: "Fund Raising and/or Fund Distribution",
      },
      {
        code: "N19",
        name: "Nonmonetary Support N.E.C.*",
      },

      {
        code: "N20",
        name: "Recreational and Sporting Camps (Day, Overnight, etc.)",
      },
      {
        code: "N30",
        name: "Physical Fitness/Community Recreational Facilities",
      },

      {
        code: "N31",
        name: "Community Recreational Centers",
      },
      {
        code: "N32",
        name: "Parks and Playgrounds",
      },

      {
        code: "N40",
        name: "Sports Training Facilities",
      },

      {
        code: "N50",
        name: "Recreational, Pleasure, or Social Club",
      },

      {
        code: "N52",
        name: "County/Street/Civic/Multi-Arts Fairs and Festivals",
      },

      {
        code: "N60",
        name: "Amateur Sports Clubs, Leagues",
      },

      {
        code: "N61",
        name: "Fishing and Hunting Clubs",
      },
      {
        code: "N62",
        name: "Basketball",
      },
      {
        code: "N63",
        name: "Baseball, Softball (includes Little Leagues)",
      },
      {
        code: "N64",
        name: "Soccer Clubs/Leagues",
      },
      {
        code: "N65",
        name: "Football Clubs/Leagues",
      },
      {
        code: "N66",
        name: "Tennis and Racquet Sports Clubs/Leagues",
      },
      {
        code: "N67",
        name: "Swimming, Water Recreation",
      },
      {
        code: "N68",
        name: "Winter Sports (Snow and Ice)",
      },
      {
        code: "N69",
        name: "Equestrian, Riding",
      },
      {
        code: "N6A",
        name: "Golf (Country Clubs, use N50)",
      },

      {
        code: "N70",
        name: "Amateur Sports Competitions",
      },

      {
        code: "N71",
        name: "Olympics Committees and Related International Competitions",
      },
      {
        code: "N72",
        name: "Special Olympics",
      },

      {
        code: "N80",
        name: "Professional Athletic Leagues",
      },
      {
        code: "N99",
        name: "Other Recreation, Sports, or Leisure Activities N.E.C.",
      },
    ],
  },
  {
    letter: "O",
    top_level: "Youth Development",
    lower_levels: [
      {
        code: "O01",
        name: "Alliance/Advocacy Organizations",
      },
      {
        code: "O02",
        name: "Management & Technical Assistance",
      },
      {
        code: "O03",
        name: "Professional Societies & Associations",
      },
      {
        code: "O05",
        name: "Research Institutes and/or Public Policy Analysis",
      },
      {
        code: "O11",
        name: "Single Organization Support",
      },
      {
        code: "O12",
        name: "Fund Raising and/or Fund Distribution",
      },
      {
        code: "O19",
        name: "Nonmonetary Support N.E.C.*",
      },

      {
        code: "O20",
        name: "Youth Centers and Clubs (includes Boys/Girls Clubs)- Multipurpose",
      },

      {
        code: "O21",
        name: "Boys Clubs",
      },
      {
        code: "O22",
        name: "Girls Clubs",
      },
      {
        code: "O23",
        name: "Boys and Girls Clubs (Combined)",
      },

      {
        code: "O30",
        name: "Adult, Child Matching Programs",
      },

      {
        code: "O31",
        name: "Big Brother, Big Sisters",
      },

      {
        code: "O40",
        name: "Scouting",
      },

      {
        code: "O41",
        name: "Boy Scouts",
      },
      {
        code: "O42",
        name: "Girl Scouts",
      },
      {
        code: "O43",
        name: "Camp Fire",
      },

      {
        code: "O50",
        name: "Youth Development Programs",
      },

      {
        code: "O51",
        name: "Community Service Clubs, Youth Development",
      },
      {
        code: "O52",
        name: "Agricultural, Youth Development",
      },
      {
        code: "O53",
        name: "Business, Youth Development",
      },
      {
        code: "O54",
        name: "Citizenship Programs, Youth Development",
      },
      {
        code: "O55",
        name: "Religious Leadership, Youth Development",
      },

      {
        code: "O99",
        name: "Other Youth Development N.E.C.",
      },
    ],
  },
  {
    letter: "P",
    top_level: "Human Services",
    lower_levels: [
      {
        code: "P01",
        name: "Alliance/Advocacy Organizations",
      },
      {
        code: "P02",
        name: "Management & Technical Assistance",
      },
      {
        code: "P03",
        name: "Professional Societies & Associations",
      },
      {
        code: "P05",
        name: "Research Institutes and/or Public Policy Analysis",
      },
      {
        code: "P11",
        name: "Single Organization Support",
      },
      {
        code: "P12",
        name: "Fund Raising and/or Fund Distribution",
      },
      {
        code: "P19",
        name: "Nonmonetary Support N.E.C.*",
      },

      {
        code: "P20",
        name: "Human Service Organizations",
      },

      {
        code: "P21",
        name: "American Red Cross",
      },
      {
        code: "P22",
        name: "Urban League",
      },
      {
        code: "P24",
        name: "Salvation Army",
      },
      {
        code: "P26",
        name: "Volunteers of America",
      },
      {
        code: "P27",
        name: "YMCA, YWCA, YWHA, YMHA",
      },
      {
        code: "P28",
        name: "Neighborhood Center, Settlement House",
      },
      {
        code: "P29",
        name: "Thrift Shops",
      },

      {
        code: "P30",
        name: "Children's and Youth Services",
      },

      {
        code: "P31",
        name: "Adoption",
      },
      {
        code: "P32",
        name: "Foster Care",
      },
      {
        code: "P33",
        name: "Child Day Care",
      },

      {
        code: "P40",
        name: "Family Services",
      },

      {
        code: "P42",
        name: "Single Parent Agencies/Services",
      },
      {
        code: "P43",
        name: "Family Violence Shelters and Services",
      },
      {
        code: "P44",
        name: "Homemaker, Home Health Aide",
      },
      {
        code: "P45",
        name: "Family Services (Adolescent Parents)",
      },
      {
        code: "P46",
        name: "Family Counseling, Marriage Counseling",
      },

      {
        code: "P50",
        name: "Personal Social Services",
      },

      {
        code: "P51",
        name: "Financial Counseling, Money Management",
      },
      {
        code: "P52",
        name: "Transportation (Free or Subsidized)",
      },
      {
        code: "P58",
        name: "Gift Distribution",
      },

      {
        code: "P60",
        name: "Emergency Assistance (Food, Clothing, Cash)",
      },

      {
        code: "P61",
        name: "Travelers' Aid",
      },
      {
        code: "P62",
        name: "Victims' Services",
      },

      {
        code: "P70",
        name: "Residential, Custodial Care (Group Home)",
      },

      {
        code: "P72",
        name: "Half-Way House (Short-Term Residential Care)",
      },
      {
        code: "P73",
        name: "Group Home (Long-Term, Primarily Assisted Living)",
      },
      {
        code: "P74",
        name: "Hospice",
      },
      {
        code: "P75",
        name: "Senior Continuing Care Communities",
      },

      {
        code: "P80",
        name: "Services to Promote the Independence of Specific Populations",
      },

      {
        code: "P81",
        name: "Senior Centers/Services",
      },
      {
        code: "P82",
        name: "Developmentally Disabled Services/Centers",
      },
      {
        code: "P84",
        name: "Ethnic/Immigrant Services",
      },
      {
        code: "P85",
        name: "Homeless Services/Centers",
      },
      {
        code: "P86",
        name: "Blind/Visually Impaired Centers, Services",
      },
      {
        code: "P87",
        name: "Deaf/Hearing Impaired Centers, Services",
      },

      {
        code: "P99",
        name: "Human Services - Multipurpose & Other N.E.C.",
      },
    ],
  },
  {
    letter: "Q",
    top_level: "International, Foreign Affairs, and National Security",
    lower_levels: [
      {
        code: "Q01",
        name: "Alliance/Advocacy Organizations",
      },
      {
        code: "Q02",
        name: "Management & Technical Assistance",
      },
      {
        code: "Q03",
        name: "Professional Societies & Associations",
      },
      {
        code: "Q05",
        name: "Research Institutes and/or Public Policy Analysis",
      },
      {
        code: "Q11",
        name: "Single Organization Support",
      },
      {
        code: "Q12",
        name: "Fund Raising and/or Fund Distribution",
      },
      {
        code: "Q19",
        name: "Nonmonetary Support N.E.C.*",
      },

      {
        code: "Q20",
        name: "Promotion of International Understanding",
      },

      {
        code: "Q21",
        name: "International Cultural Exchange",
      },
      {
        code: "Q22",
        name: "International Student Exchange and Aid",
      },
      {
        code: "Q23",
        name: "International Exchanges",
      },

      {
        code: "Q30",
        name: "International Development, Relief Services",
      },

      {
        code: "Q31",
        name: "International Agricultural Development",
      },
      {
        code: "Q32",
        name: "International Economic Development",
      },
      {
        code: "Q33",
        name: "International Relief",
      },

      {
        code: "Q40",
        name: "International Peace and Security",
      },

      {
        code: "Q41",
        name: "Arms Control, Peace Organizations",
      },
      {
        code: "Q42",
        name: "United Nations Association",
      },
      {
        code: "Q43",
        name: "Domestic National Security (includes Military and Defense Issues)",
      },

      {
        code: "Q70",
        name: "International Human Rights",
      },

      {
        code: "Q71",
        name: "International Migration, Refugee Issues",
      },

      {
        code: "Q99",
        name: "International, Foreign Affairs and National Security N.E.C.",
      },
    ],
  },
  {
    letter: "R",
    top_level: "Civil Rights, Social Action, Advocacy",
    lower_levels: [
      {
        code: "R01",
        name: "Alliance/Advocacy Organizations",
      },
      {
        code: "R02",
        name: "Management & Technical Assistance",
      },
      {
        code: "R03",
        name: "Professional Societies & Associations",
      },
      {
        code: "R05",
        name: "Research Institutes and/or Public Policy Analysis",
      },
      {
        code: "R11",
        name: "Single Organization Support",
      },
      {
        code: "R12",
        name: "Fund Raising and/or Fund Distribution",
      },
      {
        code: "R19",
        name: "Nonmonetary Support N.E.C.*",
      },

      {
        code: "R20",
        name: "Civil Rights, Advocacy for Specific Groups",
      },

      {
        code: "R22",
        name: "Minority Rights",
      },
      {
        code: "R23",
        name: "Disabled Persons' Rights",
      },
      {
        code: "R24",
        name: "Women's Rights",
      },
      {
        code: "R25",
        name: "Seniors' Rights",
      },
      {
        code: "R26",
        name: "Lesbian/Gay Rights",
      },

      {
        code: "R30",
        name: "Intergroup/Race Relations",
      },
      {
        code: "R40",
        name: "Voter Education/ Registration",
      },
      {
        code: "R60",
        name: "Civil Liberties Advocacy",
      },

      {
        code: "R61",
        name: "Reproductive Rights",
      },
      {
        code: "R62",
        name: "Right to Life",
      },
      {
        code: "R63",
        name: "Censorship, Freedom of Speech and Press Issues",
      },
      {
        code: "R67",
        name: "Right to Die, Euthanasia Issues",
      },

      {
        code: "R99",
        name: "Civil Rights, Social Action, & Advocacy N.E.C.",
      },
    ],
  },
  {
    letter: "S",
    top_level: "Community Improvement, Capacity Building",
    lower_levels: [
      {
        code: "S01",
        name: "Alliance/Advocacy Organizations",
      },
      {
        code: "S02",
        name: "Management & Technical Assistance",
      },
      {
        code: "S03",
        name: "Professional Societies & Associations",
      },
      {
        code: "S05",
        name: "Research Institutes and/or Public Policy Analysis",
      },
      {
        code: "S11",
        name: "Single Organization Support",
      },
      {
        code: "S12",
        name: "Fund Raising and/or Fund Distribution",
      },
      {
        code: "S19",
        name: "Nonmonetary Support N.E.C.*",
      },

      {
        code: "S20",
        name: "Community/Neighborhood Development, Improvement",
      },

      {
        code: "S21",
        name: "Community Coalitions",
      },
      {
        code: "S22",
        name: "Neighborhood/Block Association",
      },

      {
        code: "S30",
        name: "Economic Development",
      },

      {
        code: "S31",
        name: "Urban, Community",
      },
      {
        code: "S32",
        name: "Rural",
      },

      {
        code: "S40",
        name: "Business and Industry",
      },

      {
        code: "S41",
        name: "Promotion of Business (Chambers of Commerce)",
      },
      {
        code: "S43",
        name: "Management Services for Small Business/ Entrepreneurs",
      },
      {
        code: "S46",
        name: "Boards of Trade",
      },
      {
        code: "S47",
        name: "Real Estate Organizations",
      },

      {
        code: "S50",
        name: "Nonprofit Management",
      },
      {
        code: "S80",
        name: "Community Service Clubs (Kiwanis, Lions, Jaycees, etc.)",
      },

      {
        code: "S81",
        name: "Women's Service Clubs",
      },
      {
        code: "S82",
        name: "Men's Service Clubs",
      },

      {
        code: "S99",
        name: "Community Improvement, Capacity Building N.E.C.",
      },
    ],
  },
  {
    letter: "T",
    top_level: "Philanthropy, Voluntarism, and Grantmaking",
    lower_levels: [
      {
        code: "T01",
        name: "Alliance/Advocacy Organizations",
      },
      {
        code: "R02",
        name: "Management & Technical Assistance",
      },
      {
        code: "T03",
        name: "Professional Societies & Associations",
      },
      {
        code: "T05",
        name: "Research Institutes and/or Public Policy Analysis",
      },
      {
        code: "T11",
        name: "Single Organization Support",
      },
      {
        code: "T12",
        name: "Fund Raising and/or Fund Distribution",
      },
      {
        code: "T19",
        name: "Nonmonetary Support N.E.C.*",
      },

      {
        code: "T20",
        name: "Private Grantmaking Foundations",
      },

      {
        code: "T21",
        name: "Corporate Foundations",
      },
      {
        code: "T22",
        name: "Private Independent Foundations",
      },
      {
        code: "T23",
        name: "Private Operating Foundations",
      },

      {
        code: "T30",
        name: "Public Foundations",
      },

      {
        code: "T31",
        name: "Community Foundations",
      },

      {
        code: "T40",
        name: "Voluntarism Promotion",
      },

      {
        code: "T50",
        name: "Philanthropy/Charity/ Voluntarism Promotion (General)",
      },

      {
        code: "T70",
        name: "Fund-Raising Organizations that Cross Categories (includes Community Funds/Trusts and Federated Giving Programs) e.g. United Way",
      },

      {
        code: "T90",
        name: "Named Trusts/Foundations N.E.C.",
      },

      {
        code: "T99",
        name: "Other Philanthropy, Voluntarism, and Grantmaking Foundations N.E.C.",
      },
    ],
  },
  {
    letter: "U",
    top_level: "Science and Technology Research Institutes",
    lower_levels: [
      {
        code: "U01",
        name: "Alliance/Advocacy Organizations",
      },
      {
        code: "U02",
        name: "Management & Technical Assistance",
      },
      {
        code: "U03",
        name: "Professional Societies & Associations",
      },
      {
        code: "U05",
        name: "Research Institutes and/or Public Policy Analysis",
      },
      {
        code: "U11",
        name: "Single Organization Support",
      },
      {
        code: "U12",
        name: "Fund Raising and/or Fund Distribution",
      },
      {
        code: "U19",
        name: "Nonmonetary Support N.E.C.*",
      },

      {
        code: "U20",
        name: "Science, General (includes Interdisciplinary Scientific Activities)",
      },

      {
        code: "U21",
        name: "Marine Science and Oceanography",
      },

      {
        code: "U30",
        name: "Physical Sciences/Earth Sciences Research and Promotion",
      },

      {
        code: "U31",
        name: "Astronomy (includes Observatories)",
      },
      {
        code: "U33",
        name: "Chemistry, Chemical Engineering (includes Polymer Science)",
      },
      {
        code: "U34",
        name: "Mathematics",
      },
      {
        code: "U36",
        name: "Geology",
      },

      {
        code: "U40",
        name: "Engineering and Technology Research, Services",
      },

      {
        code: "U41",
        name: "Computer Science",
      },
      {
        code: "U42",
        name: "Engineering",
      },

      {
        code: "U50",
        name: "Biological, Life Science Research (includes Marine Biology, Physiology, Biochemistry, Genetics, Biotechnology, etc.)",
      },

      {
        code: "U99",
        name: "Science & Technology Research Institutes, Services N.E.C.",
      },
    ],
  },
  {
    letter: "V",
    top_level: "Social Science Research Institutes",
    lower_levels: [
      {
        code: "V01",
        name: "Alliance/Advocacy Organizations",
      },
      {
        code: "V02",
        name: "Management & Technical Assistance",
      },
      {
        code: "V03",
        name: "Professional Societies & Associations",
      },
      {
        code: "V05",
        name: "Research Institutes and/or Public Policy Analysis",
      },
      {
        code: "V11",
        name: "Single Organization Support",
      },
      {
        code: "V12",
        name: "Fund Raising and/or Fund Distribution",
      },
      {
        code: "V19",
        name: "Nonmonetary Support N.E.C.*",
      },

      {
        code: "V20",
        name: "Social Science Research Institutes, Services",
      },

      {
        code: "V21",
        name: "Anthropology, Sociology",
      },
      {
        code: "V22",
        name: "Economics (as a Social Science)",
      },
      {
        code: "V23",
        name: "Behavioral Science",
      },
      {
        code: "V24",
        name: "Political Science",
      },
      {
        code: "V25",
        name: "Population Studies, Demographics (includes Geography)",
      },
      {
        code: "V26",
        name: "Law, International Law, and Jurisprudence",
      },

      {
        code: "V30",
        name: "Interdisciplinary Research",
      },

      {
        code: "V31",
        name: "Black Studies",
      },
      {
        code: "V32",
        name: "Women's Studies",
      },
      {
        code: "V33",
        name: "Ethnic Studies",
      },
      {
        code: "V34",
        name: "Urban Studies",
      },
      {
        code: "V35",
        name: "International Studies",
      },
      {
        code: "V36",
        name: "Gerontology",
      },
      {
        code: "V37",
        name: "Labor Studies",
      },

      {
        code: "V99",
        name: "Social Science Research Institutes, Services N.E.C.",
      },
    ],
  },
  {
    letter: "W",
    top_level: "Public, Society Benefit",
    lower_levels: [
      {
        code: "W01",
        name: "Alliance/Advocacy Organizations",
      },
      {
        code: "W02",
        name: "Management & Technical Assistance",
      },
      {
        code: "W03",
        name: "Professional Societies & Associations",
      },
      {
        code: "W05",
        name: "Research Institutes and/or Public Policy Analysis",
      },
      {
        code: "W11",
        name: "Single Organization Support",
      },
      {
        code: "W12",
        name: "Fund Raising and/or Fund Distribution",
      },
      {
        code: "W19",
        name: "Nonmonetary Support N.E.C.*",
      },

      {
        code: "W20",
        name: "Government and Public Administration",
      },

      {
        code: "W22",
        name: "Public Finance, Taxation, Monetary Policy",
      },
      {
        code: "W24",
        name: "Citizen Participation",
      },

      {
        code: "W30",
        name: "Military/Veterans' Organizations",
      },
      {
        code: "W40",
        name: "Public Transportation Systems and Services",
      },
      {
        code: "W50",
        name: "Telephone, Telegraph, and Telecommunications Services",
      },

      {
        code: "W60",
        name: "Financial Institutions/ Services (Non-Government Related)",
      },

      {
        code: "W61",
        name: "Credit Unions",
      },

      {
        code: "W70",
        name: "Leadership Development",
      },

      {
        code: "W80",
        name: "Public Utilities",
      },

      {
        code: "W90",
        name: "Consumer Protection and Safety",
      },

      {
        code: "W99",
        name: "Public, Society Benefit - Multipurpose & Other N.E.C.",
      },
    ],
  },
  {
    letter: "X",
    top_level: "Religion, Spiritual Development",
    lower_levels: [
      {
        code: "X01",
        name: "Alliance/Advocacy Organizations",
      },
      {
        code: "X02",
        name: "Management & Technical Assistance",
      },
      {
        code: "X03",
        name: "Professional Societies & Associations",
      },
      {
        code: "X05",
        name: "Research Institutes and/or Public Policy Analysis",
      },
      {
        code: "X11",
        name: "Single Organization Support",
      },
      {
        code: "X12",
        name: "Fund Raising and/or Fund Distribution",
      },
      {
        code: "X19",
        name: "Nonmonetary Support N.E.C.*",
      },

      {
        code: "X20",
        name: "Christian",
      },

      {
        code: "X21",
        name: "Protestant",
      },
      {
        code: "X22",
        name: "Roman Catholic",
      },

      {
        code: "X30",
        name: "Jewish",
      },

      {
        code: "X40",
        name: "Islamic",
      },

      {
        code: "X50",
        name: "Buddhist",
      },

      {
        code: "X70",
        name: "Hindu",
      },

      {
        code: "X80",
        name: "Religious Media, Communications Organizations",
      },

      {
        code: "X81",
        name: "Religious Film & Video",
      },
      {
        code: "X82",
        name: "Religious Television",
      },
      {
        code: "X83",
        name: "Religious Printing, Publishing",
      },
      {
        code: "X84",
        name: "Religious Radio",
      },

      {
        code: "X90",
        name: "Interfaith Issues",
      },

      {
        code: "X99",
        name: "Religious Related, Spiritual Development N.E.C.",
      },
    ],
  },
  {
    letter: "Y",
    top_level: "Mutual/Membership Benefit Organizations, Other",
    lower_levels: [
      {
        code: "Y01",
        name: "Alliance/Advocacy Organizations",
      },
      {
        code: "Y02",
        name: "Management & Technical Assistance",
      },
      {
        code: "Y03",
        name: "Professional Societies & Associations",
      },
      {
        code: "Y05",
        name: "Research Institutes and/or Public Policy Analysis",
      },
      {
        code: "Y11",
        name: "Single Organization Support",
      },
      {
        code: "Y12",
        name: "Fund Raising and/or Fund Distribution",
      },
      {
        code: "Y19",
        name: "Nonmonetary Support N.E.C.*",
      },

      {
        code: "Y20",
        name: "Insurance Providers/ Services (other than Health)",
      },

      {
        code: "Y22",
        name: "Benevolent Life Insurance Association, Mutual Irrigations and Telephone Companies and like Organizations",
      },
      {
        code: "Y23",
        name: "Mutual Insurance Company or Association",
      },
      {
        code: "Y24",
        name: "Supplemental Unemployment Compensation",
      },
      {
        code: "Y25",
        name: "State Sponsored Worker's Compensation Reinsurance Organizations",
      },

      {
        code: "Y30",
        name: "Pension and Retirement Funds",
      },

      {
        code: "Y33",
        name: "Teachers' Retirement Fund Association",
      },
      {
        code: "Y34",
        name: "Employee Funded Pension Trust",
      },
      {
        code: "Y35",
        name: "Multi-Employer Pension Plan",
      },

      {
        code: "Y40",
        name: "Fraternal Beneficiary Societies",
      },

      {
        code: "Y42",
        name: "Domestic Fraternal Societies",
      },
      {
        code: "Y43",
        name: "Voluntary Employees Beneficiary Associations (Non-Government)",
      },
      {
        code: "Y44",
        name: "Voluntary Employees Beneficiary Associations (Government)",
      },

      {
        code: "Y50",
        name: "Cemeteries and Burial Services",
      },

      {
        code: "Y99",
        name: "Mutual/Membership Benefit Organizations, Other N.E.C",
      },
    ],
  },
  {
    letter: "Z",
    top_level: "Unknown",
    lower_levels: [
      {
        code: "Z99",
        name: "Unknown",
      },
    ],
  },
];
